export default function WhyChoose() {
  const reasons = [
    {
      icon: 'ri-cpu-line',
      title: 'Digital Fabrication Precision',
      description: 'Our advanced digital shop allows us to design, measure, and fabricate countertops with superior accuracy and efficiency for perfect fits every time.'
    },
    {
      icon: 'ri-vip-diamond-line',
      title: 'Premium Materials',
      description: 'We work exclusively with top-tier materials from trusted brands like Cambria, Dekton, Neolith, and Della Terra for exceptional quality.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Custom Fabrication',
      description: 'Every countertop is custom-fabricated to your exact specifications, ensuring a perfect match for your space and design vision.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Expert Installation',
      description: 'Our skilled craftsmen handle every installation with precision and care, delivering seamless results that exceed expectations.'
    },
    {
      icon: 'ri-time-line',
      title: 'Same-Day Service Available',
      description: 'We understand your time is valuable. Ask about our same-day service options for urgent projects and quick turnarounds.'
    },
    {
      icon: 'ri-medal-line',
      title: 'Veteran & First Responder Discount',
      description: 'We honor those who serve with a 10% discount for veterans and first responders as our way of saying thank you.'
    }
  ];

  return (
    <section id="why-choose" className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-amber-600">A-One Solid Surfacing</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Three decades of excellence in countertop craftsmanship
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-amber-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${reason.icon} text-3xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-5xl font-bold text-amber-600 mb-2">30+</div>
            <div className="text-gray-600 font-medium">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-amber-600 mb-2">5.0</div>
            <div className="text-gray-600 font-medium">Star Rating</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-amber-600 mb-2">1000+</div>
            <div className="text-gray-600 font-medium">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-amber-600 mb-2">100%</div>
            <div className="text-gray-600 font-medium">Satisfaction Rate</div>
          </div>
        </div>
      </div>
    </section>
  );
}